/**
 * @fileoverview gRPC-Web generated client stub for reportpb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v0.0.0
// source: reportpb/inventoryreport.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_type_date_pb = require('../google/type/date_pb.js')
const proto = {};
proto.reportpb = require('./inventoryreport_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.InventoryReportServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.reportpb.InventoryReportServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.reportpb.ListInventoryReportRequest,
 *   !proto.reportpb.ListInventoryReportResponse>}
 */
const methodDescriptor_InventoryReportService_ListInventoryReport = new grpc.web.MethodDescriptor(
  '/reportpb.InventoryReportService/ListInventoryReport',
  grpc.web.MethodType.UNARY,
  proto.reportpb.ListInventoryReportRequest,
  proto.reportpb.ListInventoryReportResponse,
  /**
   * @param {!proto.reportpb.ListInventoryReportRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.reportpb.ListInventoryReportResponse.deserializeBinary
);


/**
 * @param {!proto.reportpb.ListInventoryReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.reportpb.ListInventoryReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.reportpb.ListInventoryReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.reportpb.InventoryReportServiceClient.prototype.listInventoryReport =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/reportpb.InventoryReportService/ListInventoryReport',
      request,
      metadata || {},
      methodDescriptor_InventoryReportService_ListInventoryReport,
      callback);
};


/**
 * @param {!proto.reportpb.ListInventoryReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.reportpb.ListInventoryReportResponse>}
 *     Promise that resolves to the response
 */
proto.reportpb.InventoryReportServicePromiseClient.prototype.listInventoryReport =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/reportpb.InventoryReportService/ListInventoryReport',
      request,
      metadata || {},
      methodDescriptor_InventoryReportService_ListInventoryReport);
};


module.exports = proto.reportpb;

